// Slug-based theming for the embed: appConfig keys off the hostname (always
// "default" here), so we theme from the widget config's tenant slug instead.

const loadJson = async (path, fallback = {}) => {
  try {
    const res = await fetch(path);
    return res.ok ? await res.json() : fallback;
  } catch {
    return fallback;
  }
};

// Apply the tenant slug's themeVars + data-tenant to the document.
export async function applyEmbedTheme(slug) {
  const defaults = await loadJson("/configs/tenants/default.json", {});
  const overrides =
    !slug || slug === "default"
      ? defaults
      : await loadJson(`/configs/tenants/${slug}.json`, defaults);

  const themeVars = {
    ...(defaults.themeVars || {}),
    ...(overrides.themeVars || {}),
  };

  Object.entries(themeVars).forEach(([k, v]) =>
    document.documentElement.style.setProperty(k, v),
  );

  const id = overrides.id || defaults.id;
  if (id) document.body.setAttribute("data-tenant", id);

  const featureFlags = {
    ...(defaults.featureFlags || {}),
    ...(overrides.featureFlags || {}),
  };

  return { ...defaults, ...overrides, themeVars, featureFlags };
}
